import { Flex, FlexProps } from '@chakra-ui/react';
import React, { useState } from 'react';

import { render } from '../../core/support/mergeTags';
import { useAuthState } from '../AuthState';

type Props = FlexProps & {
  html: string;
};

export default function EmailPreview(props: Props) {
  const { html, ...otherProps } = props;
  const { account } = useAuthState();
  const [objectUrl] = useState(() => {
    const renderedHtml = render(html, {
      year: new Date().getFullYear().toString(),
      accountName: account.name,
    });
    const encoded = new TextEncoder().encode(renderedHtml);
    const arrayBuffer = encoded.buffer;
    const blob = new Blob([arrayBuffer], { type: 'text/html' });
    return URL.createObjectURL(blob);
  });
  return (
    <Flex direction="column" flex={1} position="relative" {...otherProps}>
      <iframe
        frameBorder={0}
        style={{ display: 'block', width: '100%', height: '100%', border: 0 }}
        src={objectUrl}
      />
    </Flex>
  );
}
